const ActionHeaderClasses = Object.freeze({
	Base: 'm-action-header',
	// Sizes
	Small: 'm-action-header--s',
});

export { ActionHeaderClasses };
